"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPopulation = exports.setPopulation = exports.setTheme = exports.setShareOfAudience = exports.setShareOfAttribute = exports.setIndex = exports.resetTheme = exports.resetShareOfAudience = exports.resetShareOfAttribute = exports.resetIndex = exports.RESET_POPULATION = exports.SET_POPULATION = exports.SET_THEME = exports.SET_SHARE_OF_AUDIENCE = exports.SET_SHARE_OF_ATTRIBUTE = exports.SET_INDEX = exports.RESET_THEME = exports.RESET_SHARE_OF_AUDIENCE = exports.RESET_SHARE_OF_ATTRIBUTE = exports.RESET_INDEX = void 0;
var RESET_INDEX = 'RESET_INDEX';
exports.RESET_INDEX = RESET_INDEX;
var RESET_SHARE_OF_ATTRIBUTE = 'RESET_SHARE_OF_ATTRIBUTE';
exports.RESET_SHARE_OF_ATTRIBUTE = RESET_SHARE_OF_ATTRIBUTE;
var RESET_SHARE_OF_AUDIENCE = 'RESET_SHARE_OF_AUDIENCE';
exports.RESET_SHARE_OF_AUDIENCE = RESET_SHARE_OF_AUDIENCE;
var RESET_THEME = 'RESET_THEME';
exports.RESET_THEME = RESET_THEME;
var SET_INDEX = 'SET_INDEX';
exports.SET_INDEX = SET_INDEX;
var SET_SHARE_OF_ATTRIBUTE = 'SET_SHARE_OF_ATTRIBUTE';
exports.SET_SHARE_OF_ATTRIBUTE = SET_SHARE_OF_ATTRIBUTE;
var SET_SHARE_OF_AUDIENCE = 'SET_SHARE_OF_AUDIENCE';
exports.SET_SHARE_OF_AUDIENCE = SET_SHARE_OF_AUDIENCE;
var SET_THEME = 'SET_THEME';
exports.SET_THEME = SET_THEME;
var SET_POPULATION = 'SET_POPULATION';
exports.SET_POPULATION = SET_POPULATION;
var RESET_POPULATION = 'RESET_POPULATION';
exports.RESET_POPULATION = RESET_POPULATION;

var resetIndex = function resetIndex() {
  return {
    type: RESET_INDEX
  };
};

exports.resetIndex = resetIndex;

var resetShareOfAttribute = function resetShareOfAttribute() {
  return {
    type: RESET_SHARE_OF_ATTRIBUTE
  };
};

exports.resetShareOfAttribute = resetShareOfAttribute;

var resetShareOfAudience = function resetShareOfAudience() {
  return {
    type: RESET_SHARE_OF_AUDIENCE
  };
};

exports.resetShareOfAudience = resetShareOfAudience;

var resetTheme = function resetTheme(value) {
  return {
    type: RESET_THEME,
    payload: value
  };
};

exports.resetTheme = resetTheme;

var setIndex = function setIndex(value) {
  return {
    type: SET_INDEX,
    payload: value
  };
};

exports.setIndex = setIndex;

var setShareOfAttribute = function setShareOfAttribute(value) {
  return {
    type: SET_SHARE_OF_ATTRIBUTE,
    payload: value
  };
};

exports.setShareOfAttribute = setShareOfAttribute;

var setShareOfAudience = function setShareOfAudience(value) {
  return {
    type: SET_SHARE_OF_AUDIENCE,
    payload: value
  };
};

exports.setShareOfAudience = setShareOfAudience;

var setTheme = function setTheme(value) {
  return {
    type: SET_THEME,
    payload: value
  };
};

exports.setTheme = setTheme;

var setPopulation = function setPopulation(value) {
  return {
    type: SET_POPULATION,
    payload: value
  };
};

exports.setPopulation = setPopulation;

var resetPopulation = function resetPopulation() {
  return {
    type: RESET_POPULATION
  };
};

exports.resetPopulation = resetPopulation;